<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div :class="sectionClass">
    <label v-if="label" :for="id" :class="labelClass">{{ label }}</label>
    <div class="input-group" :class="{ 'p-invalid': validation?.$error }">
      <span v-if="prefix" class="input-group-addon" :class="prefix">
        <slot name="prefix"></slot>
      </span>
      <input
        type="number"
        :id="id"
        class="input-group-field w-full rounded inputnumfocus"
        :value="modelValueComputed"
        :disabled="disabled"
        :placeholder="placeholder"
        :min="min"
        :max="max"
        :class="{ 'p-invalid': validation?.$error }"
        :aria-describedby="`${id}-help`"
        @input="onInput"
      />
      <button v-if="px" class="px-btn"  :disabled="disabled">px</button>
      <div v-if="suffix" class="input-group-controls">
        <button
          type="button"
          class="increment-btn"
          :disabled="disabled || (max !== null && modelValueComputed >= max)"
          @click="increment"
        >
          <i class="angle-up"></i>
        </button>
        <button
          type="button"
          class="decrement-btn"
          style="padding-left: 6px;"
          :disabled="disabled || (min !== null && modelValueComputed <= min)"
          @click="decrement"
        >
          <i class="angle-down"></i>
        </button>
      </div>
      <span v-if="suffixEl" class="input-group-addon" :class="suffixEl">
        <slot name="slotsuffix"></slot>
      </span>
    </div>
    <span
      v-if="
        validation?.$error &&
        validation.required &&
        validation.required.$invalid
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.required.$message.replace("Value", PropName) }}
    </span>
    <span
      v-if="
        validation?.$error &&
        validation.minValue &&
        validation.minValue.$invalid
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.minValue.$message.replace("Value", PropName) }}
    </span>
    <span
      v-if="
        validation?.$error &&
        validation.maxValue &&
        validation.maxValue.$invalid
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.maxValue.$message.replace("Value", PropName) }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    labelClass: {
      type: String,
      default: "form-label",
    },
    PropName: {
      type: String,
      default: "",
    },
    sectionClass: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      required: true,
      default: "",
    },
    label: {
      type: String,
      required: false,
      default: "",
    },
    validation: {
      type: Object,
      required: false,
    },
    modelValue: {
      type: [Number, String],
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    prefix: {
      type: String,
      default: "",
    },
    slotsuffix: {
      type: String,
      default: "",
    },
    min: {
      type: Number,
      default: null,
    },
    max: {
      type: Number,
      default: null,
    },
    suffix: {
      type: Boolean,
      default: true, // Show buttons by default
    },
    px: {
      type: Boolean,
      default: false, // Show buttons by default
    },

    nullable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    modelValueComputed: {
      get() {
        if (
          this.nullable &&
          (this.modelValue === null || this.modelValue === "")
        ) {
          return "";
        }
        return this.modelValue === null ? 0 : this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    suffixEl() {
      return this.slotsuffix ? this.slotsuffix : "";
    },
  },
  methods: {
    onInput(event) {
      const empty = event.target.value === "";
      const num = event.target.valueAsNumber;
      if (empty || Number.isNaN(num)) {
        this.$emit("update:modelValue", this.nullable ? null : 0);
        return;
      }
      this.$emit("update:modelValue", num);
    },
    increment() {
      const newValue = (this.modelValueComputed || 0) + 1;
      if (this.max === null || newValue <= this.max) {
        this.$emit("update:modelValue", newValue);
      }
    },
    decrement() {
      const newValue = (this.modelValueComputed || 0) - 1;
      if (this.min === null || newValue >= this.min) {
        this.$emit("update:modelValue", newValue);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.px-btn {
  border: none;
  height: 38px !important;
  background-color: #fff;
  // border-top: 1px solid #c0c0bc;
  // border-bottom: 1px solid #c0c0bc;
  color: #222222;
  &:disabled {
    opacity: 0.6;
    background-color: #F0F0EF !important;
    cursor: not-allowed;
  }
}
.px-btn:disabled{
  background-color: #c0c0c0;
  opacity: 0.6;
}
.input-group {
  display: flex;
  align-items: center;
  border: 1px solid #c0c0bc;
  border-radius: 0.25rem;
  overflow: hidden;
  height: 40px;

  &.p-invalid {
    border-color: #dc3545;
  }
}
.input-group:disabled{
  background-color: #c0c0c0;
  opacity: 0.6;
}
.input-group-field:enabled:focus {
  outline: none !important;
}
.input-group-field {
  color: #21211f !important;
  font-size: 16px;
  resize: none;
  box-shadow: none;
  border: none;
  font-weight: 500;
  line-height: 1;
  font-family: "voyado Text";
  padding: 0.5rem;
  min-width: 36px;
  background-color: transparent;

&:disabled {
    opacity: 0.6;
    background-color: #F0F0EF;
    cursor: not-allowed;
  }
  // &:enabled:focus {
  //   outline: 0 none;
  //   outline-offset: 0;
  //   box-shadow: none !important;
  //   outline: 2px solid #222222 !important;
  //   border-style: double !important;
  // }

  /* Hide default number input spinners */
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}

.input-group-addon {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffff;
  color: #21211f;
  font-size: 16px;
  font-family: "voyado Text";
  min-width: 36px;
  margin-left: 16px;
}

.input-group-controls {
  display: flex;
  flex-direction: column;
  height: 100%;
  border-left: 1px solid #c0c0bc;
}

.increment-btn,
.decrement-btn {
 background-color: #ffffff;
  color: #21211f;
  border: none;
  padding: 0.25rem 0.5rem;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
flex: 1; /* Ensures both buttons take equal height */
 height: 50%; /* Alternative: explicitly set to half the container height */

  &:disabled {
    opacity: 0.6;
     background-color: #F0F0EF;
    cursor: not-allowed;
  }
}

.increment-btn {
  border-bottom: 1px solid #c0c0bc;
}
</style>
